<member-section-item *ngIf="id" [id]="id"></member-section-item>
<member-section-list *ngIf="!id" [editMode]="editMode" [page]="page" [section]="section"></member-section-list>
